import { Component, Input, OnInit } from '@angular/core';
import { EMessageItemStatus, IMessageItem } from '../../../store/models/message.model';
import { IUserSessionData, UserType } from '../../../store/models/user.model';

@Component({
  selector: 'app-list-messages-mobile-row',
  templateUrl: './list-messages-mobile-row.component.html',
  styleUrls: ['./list-messages-mobile-row.component.scss'],
})
export class ListMessagesMobileRowComponent implements OnInit {

  @Input() row: IMessageItem;
  @Input() currentUser: IUserSessionData;

  constructor() {
  }

  get contact() {
    if (!this.row.contact_firstname && !this.row.contact_lastname) {
      return this.row.contact_email;
    }

    return `${this.row.contact_firstname || ''} ${this.row.contact_lastname}`;
  }

  get company() {
    return this.row.company;
  }

  get subject() {
    return this.row.subject;
  }

  get representative() {
    return `${this.row.representative_firstname} ${this.row.representative_lastname}`;
  }

  get isSingleUser() {
    return this.currentUser?.user_type === UserType.SINGLE_USER;
  }

  get classes(): string {
    const classes = [];

    if (!this.row.read_status) {
      classes.push('bolded_row');
    }

    if (this.row.message_status === EMessageItemStatus.ALERT_SUCCERSS) {
      classes.push('alert-success');
    }

    if (this.row.message_status?.indexOf('unmatched_msg') !== -1) {
      classes.push('alert-danger');
    }

    if (this.row.message_status?.indexOf('universal_contact') !== -1) {
      classes.push('italic-row');
    }

    return classes.join(' ');
  }

  ngOnInit(): void {
  }

}
